// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__E34CN","copyright":"Footer_copyright__cTEvY"};